var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.445 20.4532H16.8953V14.883C16.8953 13.5547 16.8675 11.8477 15.039 11.8477C13.188 11.8477 12.906 13.2885 12.906 14.7847V20.4525H9.35175V8.99925H12.7657V10.5615H12.8115C13.2885 9.65925 14.4487 8.7105 16.1797 8.7105C19.7805 8.7105 20.4487 11.0813 20.4487 14.1638V20.4525L20.445 20.4532ZM5.33625 7.434C5.06496 7.4341 4.79631 7.38068 4.54569 7.27679C4.29508 7.1729 4.06742 7.02059 3.87576 6.82858C3.6841 6.63658 3.53221 6.40864 3.42878 6.15784C3.32534 5.90704 3.27241 5.63829 3.273 5.367C3.27344 4.95866 3.39496 4.55963 3.62217 4.22034C3.84939 3.88106 4.1721 3.61677 4.54951 3.46088C4.92692 3.30499 5.34208 3.26451 5.74249 3.34456C6.14291 3.4246 6.5106 3.62158 6.79907 3.91058C7.08755 4.19958 7.28385 4.56763 7.36317 4.96818C7.44249 5.36874 7.40125 5.78383 7.24468 6.16095C7.08811 6.53808 6.82323 6.86031 6.48354 7.08691C6.14384 7.31351 5.74459 7.4343 5.33625 7.434V7.434ZM7.11675 20.4532H3.555V9H7.11675V20.4532ZM22.227 0H1.77C0.79275 0 0 0.77325 0 1.73025V22.2705C0 23.2275 0.79275 24.0007 1.77 24.0007H22.2233C23.199 24.0007 24 23.2275 24 22.2705V1.73025C24 0.77325 23.199 0 22.2233 0H22.227Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/linkedin-logo.e1766c59.svg";
export { ForwardRef as ReactComponent };